interface MenuItemVisibilityFields {
  item_name?: string;
  price?: unknown;
}

// price 0 is a valid price (free refills, complimentary sides), so check the
// price is a number instead of checking it is truthy. an unset price is still
// treated as no price: the form seeds it with an empty string
export const hasDisplayablePrice = (price: unknown): boolean =>
  price !== null && price !== "" && Number.isFinite(Number(price));

export const isOrderableMenuItem = (item: MenuItemVisibilityFields): boolean =>
  Boolean(item?.item_name) && hasDisplayablePrice(item?.price);

export const getDisplayableDescription = (description: unknown): string =>
  typeof description === "string" ? description.trim() : "";
